import React from "react";
import ContentSection from "./ContentSection";
import Heading from "./Heading";
import AccordionSection from "./AccordionSection";
import DescriptionSection from "../common/Description";
import TableSection from "./TableSection";
import FaqsSection from "./FaqSection";
import YouTubeEmbed from "../blog/YoutubeEmbed";
import TeamSection from "../about/TeamSection";
import Listings from "./Listings";
import VideoSection from "./VideoSection";

export const _renderSection = (item, key) => {
  switch (item._type) {
    case "contentSection2":
      return <ContentSection key={key} data={item} index={key} />;
    case "videoContent":
      return <VideoSection key={key} data={item} index={key} />;
    case "heading":
      return <Heading key={key} data={item} />;
    case "accordionSection":
      return <AccordionSection key={key} data={item} index={key} />;
    case "descriptionSection":
      return <DescriptionSection key={key} data={item} index={key} />;
    case "tableSection":
      return <TableSection key={key} data={item} index={key} />;
    case "faqsSection":
      return <FaqsSection key={key} data={item} index={key} />;
    case "youtube":
      return (
        <div className="px-section w-full">
          <div className="max-w-6xl mx-auto">
            <YouTubeEmbed key={key} value={item} index={key} />
          </div>
        </div>
      );
    case "ourTeam":
      return <TeamSection key={key} data={item} index={key} />;
    case "listingSection":
      return <Listings key={key} data={item} index={key} />;
  }
};
